import axios from "axios";
import { fetchBaseUrl } from "core/utils/common";
import { API_ENDPOINT } from "core/utils/constants";
import { getCsrfTokenFromCookie } from "core/utils/csrf";

const ac2BaseURL = `${fetchBaseUrl({ port: 8081 })}/ac2/ui`;
const flywheelBaseURL = `${fetchBaseUrl({ port: 8090 })}/socai/ui`;

const getServiceBaseURL = (module?: string) => {
  // If module is explicitly provided, use it
  if (module === "socai" || module === "flywheel") return flywheelBaseURL;
  if (module === "ac2") return ac2BaseURL;

  // Otherwise check URL for module name
  const currentPath = window.location.pathname;
  if (currentPath.includes("/flywheel/")) return flywheelBaseURL;
  return ac2BaseURL; // Default to ac2
};

export const setUserService = async (
  config,
  email: string,
  firstName: string,
  lastName: string,
  lastLoggedIn: number,
  module?: string
) => {
  const baseURL = getServiceBaseURL(module);
  const url = `${baseURL}/${API_ENDPOINT.IDM_USERS}`;
  try {
    const csrfToken = getCsrfTokenFromCookie();
    const response = await axios.request({
      method: "POST",
      url: url,
      data: JSON.stringify({
        email: email,
        firstName: firstName,
        lastName: lastName,
        lastLoggedIn: lastLoggedIn,
      }),
      headers: {
        ...config,
        "X-CSRF-Token": csrfToken,
      },
    });
    return response;
  } catch (error) {
    console.error(
      `Error setting user in ${module || "current module"}:`,
      error
    );
    return null;
  }
};

export const getUsersService = async (config, module?: string) => {
  const baseURL = getServiceBaseURL(module);

  try {
    const response = await axios.request({
      method: "GET",
      url: `${baseURL}/${API_ENDPOINT.IDM_USERS}`,
      headers: config,
    });

    const responseData = await response.data;
    responseData.push({
      sub: "",
      given_name: "1",
      family_name: "2",
      email: "",
      email_verified: true,
      preferred_username: "",
    });
    return responseData;
  } catch (error) {
    console.error(
      `Error getting users from ${module || "current module"}:`,
      error
    );
    // Return empty array with just the empty user option
    return [
      {
        sub: "",
        given_name: "1",
        family_name: "2",
        email: "",
        email_verified: true,
        preferred_username: "",
      },
    ];
  }
};
